import { z } from 'zod';

export const ManagedBehaviorOwnerSchema = z.enum([
  'tss_template',
  'tss_blueprint',
  'tss_migration',
]);

/**
 * Identity shared by the binding, listener, and action that form one managed
 * semantic behavior set. Operator-authored artifacts omit this field.
 */
export const ManagedSemanticBehaviorSchema = z
  .object({
    behaviorSetId: z
      .string()
      .min(1)
      .max(160)
      .regex(/^[a-zA-Z0-9][a-zA-Z0-9._:-]*$/),
    owner: ManagedBehaviorOwnerSchema,
    revision: z.number().int().positive(),
  })
  .strict();

export type ManagedBehaviorOwner = z.infer<
  typeof ManagedBehaviorOwnerSchema
>;
export type ManagedSemanticBehavior = z.infer<
  typeof ManagedSemanticBehaviorSchema
>;
